export var DisplayMode;
(function (DisplayMode) {
    /**
     * 网页版显示模式
     */
    DisplayMode[DisplayMode["Web"] = 0] = "Web";
    /**
     * 移动端显示，优化部分元件在移动端中的显示效果
     */
    DisplayMode[DisplayMode["Mobile"] = 1] = "Mobile";
})(DisplayMode || (DisplayMode = {}));
